import * as React from 'react';

import type {Assignable} from 'nutshell-core/types';

import {Button} from '../../button/button';
import {CloseButton} from '../../button/close-button/close-button';
import {UserOutlineIcon} from '../../icon/svg/user-outline-icon';
import {Stack} from '../../layout/stack/stack';

import {getAssigneeName} from './helpers';

type Props = {
    assignables: Assignable[];
    assigneeId: string | null | undefined;
    getAssigneeRef: (arg1?: HTMLElement | null | undefined) => void;
    onAssigneePopoverOpen: (isAssigneePopoverOpen: boolean) => void;
    onUpdateAssignee?: (assigneeId?: string | null | undefined) => void;
    canClear?: boolean;
};

export function TaskAssigneeSelector(props: Props) {
    const assigneeName = React.useMemo(
        () => props.assigneeId && getAssigneeName(props.assignables, props.assigneeId),
        [props.assignables, props.assigneeId]
    );

    return (
        <>
            <Button
                variant={props.assigneeId ? 'text' : 'text-secondary'}
                onClick={(e) => {
                    e.stopPropagation();
                    props.onAssigneePopoverOpen(true);
                }}
                noPadding={true}
                overflowHidden={true}
            >
                <Stack
                    isHorizontal={true}
                    spacing={4}
                    alignItems='center'
                    getRef={props.getAssigneeRef}
                >
                    <UserOutlineIcon size={16} />
                    <div className='truncate' data-tip={assigneeName}>
                        {assigneeName || 'Assign…'}
                    </div>
                </Stack>
            </Button>
            {props.assigneeId && props.canClear && (
                <CloseButton
                    size={10}
                    variant='dark'
                    className='mt-2 no-padding px-6'
                    onClick={(e) => {
                        e.stopPropagation();
                        props.onUpdateAssignee?.(null);
                    }}
                />
            )}
        </>
    );
}
